module.exports = __webpack_public_path__ + "img/antes_despues_128.53064b46.png";